import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { equals } from 'ramda';
import { Button } from '../../../Common';

export const Pagination = (props) => {
  const {
    title = 'Pagination',
    export: exportFn = () => {},
    ariaOff = false,
    onPagination = () => {},
  } = props;
  const usersList = useSelector(state => state.Users.usersList);
  let marginPagesDisplayed;
  let pageRangeDisplayed;

  const handlePageClick = (data) => {
    rules(data.selected);
  };

  const rules = (selected) => {
    const passParent = {
      pageNumber: selected,
      pageSize: usersList.pageSize,
    };
    onPagination(passParent);
  };

  const onChange = (selected) => {
    if (parseInt(selected, 10) >= 1 && parseInt(selected, 10) <= usersList.totalPages) {
      rules(parseInt(selected, 10) - 1);
    }
  };

  const perPage = (items) => {
    const passParent = {
      pageNumber: 0,
      pageSize: items,
    };
    onPagination(passParent);
  };

  const ellipsesRemove = () => {
    var containerDiv = document.getElementsByClassName('break-me');
    if (containerDiv.length > 0) {
      for (var i = 0; i < containerDiv.length; i++) {
        var ellipse = document.createElement('span');
        ellipse.setAttribute('id', 'ellipse' + i);
        var ellipseIcon = document.createElement('i');
        ellipseIcon.setAttribute('class', 'far fa-ellipsis-h');
        ellipse.appendChild(ellipseIcon);
        containerDiv[i].appendChild(ellipse);
        var child = document.getElementById('ellipse' + i);
        containerDiv[i].removeChild(child);
        containerDiv[i].appendChild(ellipse);
      }
    }
  };
  
  const exportData = () => {
    exportFn();
  };

  const renderTotalResultsCounter = React.useCallback(() => {
    return usersList.totalElements === 0 ? 'No Results' : `${usersList.totalElements || ''} Results Total`
  }, [usersList.totalElements]);

  React.useEffect(() => {
    ellipsesRemove();
  }, []);

  if (usersList.totalPages > 6) {
    let checkArr = [0, 1, usersList.totalPages - 2, usersList.totalPages - 1];
    let condition = checkArr.indexOf(usersList.pageNumber);
    if (condition !== -1) {
      marginPagesDisplayed = 3;
      pageRangeDisplayed = 2;
    } else if (usersList.pageNumber === 2 || usersList.pageNumber === usersList.totalPages - 3) {
      marginPagesDisplayed = 3;
      pageRangeDisplayed = 3;
    } else {
      marginPagesDisplayed = 1;
      pageRangeDisplayed = 2;
    }
  } else {
    marginPagesDisplayed = 1;
    pageRangeDisplayed = 6;
  }

  return (
    <div className="pagination-group row" role="navigation" aria-label={title} tabIndex={0}>
      <div className={'col-sm-4 goTo'}>
        {usersList.totalPages > 1 ? (
          <div className="v-middle-align">
            <label className="ScalaSansOT fontSm-15">Go To Page:</label>
            <div className="input-left">
              <input
                id="input-page-no"
                aria-label="go to page number input"
                type="number"
                value={(usersList.pageNumber + 1).toString()}
                className="input"
                name="current"
                onChange={(current) => onChange(current.target.value)}
              />
            </div>
          </div>
        ) : void 0}
      </div>

      <div className="col-sm-4 paginate">
        {usersList.totalPages > 1 ? (
          <div className="pagination" aria-live={ariaOff ? 'off' : 'polite'}>
            <ReactPaginate
              previousLabel={
                <Fragment>
                  previous page <i className="far fa-caret-left"></i>
                </Fragment>
              }
              nextLabel={
                <Fragment>
                  next page<i className="far fa-caret-right"></i>
                </Fragment>
              }
              breakLabel={<i className="far fa-ellipsis-h"></i>}
              breakClassName={'break-me'}
              forcePage={usersList.pageNumber}
              pageCount={usersList.totalPages}
              marginPagesDisplayed={marginPagesDisplayed}
              pageRangeDisplayed={pageRangeDisplayed}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
          </div>
        ) : void 0}
      </div>

      <div className={'col-sm-4'}>
        <div className="perPage">
          <div className="v-middle-align">
            {usersList.totalPages > 1 ? (
              <label className="ScalaSansOT fontSm-15">Results Per Page:</label>
            ) : void 0}
            {(usersList.totalPages > 1 || usersList.totalUsers > 25) ? (
              <div className="">
                <ul role="list" aria-label="Set Display Results Per Page">
                  <li className={25 === usersList.pageSize ? 'active' : 'in-active'}>
                    <span
                      role="button"
                      aria-label="Set Page Size to 25"
                      tabIndex={0}
                      aria-pressed={25 === usersList.pageSize}
                      onKeyDown={(e) => (e.key === 'Enter' ? perPage(25) : void 0)}
                      onClick={() => perPage(25)}
                      className="verticle-middle">
                      25
                    </span>
                  </li>
                  <li className={50 === usersList.pageSize ? 'active' : 'in-active'}>
                    <span
                      role="button"
                      aria-label="Set Page Size to 50"
                      aria-pressed={50 === usersList.pageSize}
                      tabIndex={0}
                      onKeyDown={(e) => (e.key === 'Enter' ? perPage(50) : void 0)}
                      onClick={() => perPage(50)}
                      className="verticle-middle">
                      50
                    </span>
                  </li>
                  <li className={100 === usersList.pageSize ? 'active' : 'in-active'}>
                    <span
                      role="button"
                      aria-label="Set Page Size to 100"
                      tabIndex={0}
                      aria-pressed={100 === usersList.pageSize}
                      onKeyDown={(e) => (e.key === 'Enter' ? perPage(100) : void 0)}
                      onClick={() => perPage(100)}
                      className="verticle-middle">
                      100
                    </span>
                  </li>
                </ul>
              </div>
            ) : void 0}
            <div className="totalUsers text-center fontSm-15 pLeft-10">
              <span tabIndex={0}>{renderTotalResultsCounter()}</span>
              <span className="lsn-gray"> | </span>
              <Button
                isNew
                shrank
                size='link'
                text='Export'
                aria-label='Export User Data.'
                appearance='link'
                onClick={() => exportData()}
                id='button-users-export'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Pagination, (prev, next) => {
  const res = equals(prev.title, next.title);
  return res;
});
